import { getAuthenticationHeaders } from "common/apis/APIUtility";
import elcos from "common/apis/ElcosAPI";

const UsersService = {
  getAll: async () => {
    const config = await getAuthenticationHeaders();

    return await elcos.get("/users", config);
  },
  getByUsername: async (username) => {
    const config = await getAuthenticationHeaders();

    return await elcos.get(`/users/${username}`, config);
  },
  editAttributes: async (username, attributes) => {
    const config = await getAuthenticationHeaders();
    const body = { attributes }
    return await elcos.post(`/users/${username}/attributes`, body, config);
  },
  editSettings: async (username, newSettings) => {
    const config = await getAuthenticationHeaders();
    return await elcos.post(`/users/${username}/settings`, newSettings, config);
  },
  deleteByUsername: async (username) => {
    const config = await getAuthenticationHeaders();
    return await elcos.delete(`/users/${username}`, config);
  },
  getUserSettings: async (username) => {
    const config = await getAuthenticationHeaders();
    return await elcos.get(`/users/${username}/settings`, config);
  }
};

export default UsersService;
